import { render, staticRenderFns } from "./GlobalNavDrawer.vue?vue&type=template&id=207dcd0e&scoped=true"
import script from "./GlobalNavDrawer.vue?vue&type=script&lang=ts"
export * from "./GlobalNavDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207dcd0e",
  null
  
)

export default component.exports